/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tired_Extra_Dachshund_BubbleInputs */

const fr_tired_extra_dachshund_bubble = /** @type {(inputs: Tired_Extra_Dachshund_BubbleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coins`)
};

/**

* @param {Tired_Extra_Dachshund_BubbleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tired_extra_dachshund_bubble = /** @type {((inputs?: Tired_Extra_Dachshund_BubbleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tired_Extra_Dachshund_BubbleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tired_extra_dachshund_bubble(inputs)
});